export const refreshes = (state) => state.refreshes

export const refreshFor = (state) => (podcastKey) => (podcastKey ? state.refreshes[podcastKey] ?? null : null)

export const isRefreshing = (state) => (podcastKey) => !!state.refreshes[podcastKey]
